import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import {SurveyQuestionComponent, SurveyTab} from '../surveyquestion/surveyquestion.component';
import { SurveyManagementService } from './../survey-management.service';

import { SurveyQuestion } from '../../../shared/models/survey/survey-question.model';
import { SurveyTemplate } from '../../../shared/models/survey/survey-template.model';
import { environment } from 'environments/environment';
import {SurveyResponseListComponent} from '../response/survey-response-list.component';
import {SurveyQuestionType} from '../../../shared/models/survey/survey-question-type.enum';


@Component({
  selector: 'surveyquestion-list',
  templateUrl: './surveyquestion-list.component.html'
})

/**
 * Component for display the survey question list.
 */
export class SurveyQuestionListComponent implements OnInit {
  @Input()
  surveyTemplates: SurveyTemplate[];

  dialogRef: MdDialogRef<any>;
  surveyQuestions: SurveyQuestion[];
  surveyQuestionsLoaded = false;
  selectSurveyNameForm: FormGroup;
  defaultSelectedTemplate: number;
  selectedTemplate: SurveyTemplate;
  selectedQuestion: SurveyQuestion;
  showSurveyActions = environment.showSurveyActions;
  SurveyQuestionType: typeof SurveyQuestionType = SurveyQuestionType;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private surveyManagementService: SurveyManagementService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) { }

  ngOnInit() {
    this.getSurveyTemplates();
  }

  getSurveyTemplates() {
    this.surveyManagementService.getSurveyTemplates()
      .subscribe(response => {
        this.surveyTemplates = response;
        this.defaultSelectedTemplate = this.surveyTemplates[0].id;
        this.surveyManagementService.setSurveyTemplatesInCache(response);
        this.onTemplateChange(this.defaultSelectedTemplate);
      });
  }

  openSurveyQuestionDialog(action: string, questionIndex: number) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(SurveyQuestionComponent, config);
    this.dialogRef.componentInstance.selectedTemplate = this.selectedTemplate;
    this.dialogRef.componentInstance.selectedSurveyQuestion = this.selectedQuestion;
    this.dialogRef.componentInstance.action = action;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        if (action == 'Add') {
          this.selectedTemplate.questions.push(result.arrResult);
        } else if(action == 'Edit') {
          this.selectedTemplate.questions[questionIndex] = result.arrResult;
        }
      }
      this.selectedQuestion = null;
    });
  }

  onTemplateChange(templateId: number) {
    this.surveyManagementService.listSurveyQuestions(templateId)
      .subscribe(response => {
        this.surveyQuestions = response.questions;
        this.selectedTemplate = response;
      });
  }

  editSurveyQuestion(value: SurveyQuestion, index): void {
    this.selectedQuestion = value;
    this.openSurveyQuestionDialog('Edit', index);
  }

  deleteSurveyQuestion(value: SurveyQuestion, index): void {
    this.surveyManagementService.listSurveyResponsesForQuestion(value.id)
      .subscribe(answers => {
        if (answers.length > 0) {
          this.selectedQuestion = value;
          this.openSurveyQuestionDialog('Delete', index);
          this.dialogRef.componentInstance.surveyResponses = answers;
          this.dialogRef.componentInstance.selectedTab = SurveyTab.Responses;
          this.dialogRef.componentInstance.disabled = true;
          this.dialogRef.componentInstance.allQuestions = this.surveyQuestions;
          this.dialogRef.afterClosed().subscribe(response => {
            if (response === 'Delete') {
              this.deleteQuestion(value);
            }
          });
        } else {
          this.deleteQuestion(value);
        }
      });
  }

  private deleteQuestion(question: SurveyQuestion) {
    this.surveyManagementService.deleteSurveyQuestion(question)
      .subscribe(response => {
        if (response.flagResult) {
          this.surveyQuestions.splice(this.surveyQuestions.indexOf(question), 1);
        }
        this.trackingService
          .emitEvent(
            TrackingConstants.SURVEY_MANAGEMENT,
            TrackingConstants.DELETE_SURVEY_TEMPLATE,
            TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
        this.trackingService
          .emitEvent(
            TrackingConstants.SURVEY_MANAGEMENT,
            TrackingConstants.DELETE_SURVEY_TEMPLATE,
            TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err);
      });
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.DELETE_SURVEY_QUESTION_SUCCESS,
      MessageService.SURVEY_QUESTION_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/survey/surveyquestionlist/surveyquestion-list.component.ts